import { render } from "./xjmanage.vue?vue&type=template&id=b7448174&scoped=true"
import script from "./xjmanage.vue?vue&type=script&lang=js"
export * from "./xjmanage.vue?vue&type=script&lang=js"

import "./xjmanage.vue?vue&type=style&index=0&id=b7448174&lang=scss&scoped=true"
import "./xjmanage.vue?vue&type=style&index=1&id=b7448174&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7448174"]])

export default __exports__